<template>
  <div class="illegalWordView">
    <navBar :idFixedDiv="true" ref="navBar" @reload="reload"></navBar>
    <div class="illegalWord">
      <div class="navLeft">
        <el-row style="height:100%" class="navLeftRow">
          <el-col style="height:100%">
            <el-menu :default-active="activeIndex" class="el-menu-vertical" @open="handleOpen" @close="handleClose">
              <router-link :to="item.link" v-for="(item, index) in navLeft" :key="index">
                <el-menu-item :index="item.index" class="navLeftItem" :title="item.text">
                  <template slot="title">
                    {{ item.text }}
                  </template>
                </el-menu-item>
              </router-link>
            </el-menu>
          </el-col>
        </el-row>
      </div>
      <div class="content">
        <router-view v-if="isRouterShow"></router-view>
      </div>
    </div>
    <div class="optionPanle" style="z-index:999999;position:fixed;display:none">
      <span class="codeModifyBanBody" style="position: fixed;">
        <span class="codeModifyBan">
          <span class="delete curp">清除</span>
          <span class="switch curp">替换</span>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import navBar from "../nav/nav.vue";
export default {
  components: { navBar },
  data() {
    return {
      activeIndex: "1",
      navLeft: [{ link: "/illegalFont/fontCheck", text: "方正字体检测", index: "1" }],
      isRouterShow: true,
    };
  },
  updated() {
    if (this.$route.name.indexOf("fontCheck") != -1) {
      this.activeIndex = "1";
    }
  },
  mounted() {
    if (this.$route.name.indexOf("fontCheck") != -1) {
      this.activeIndex = "1";
    }
  },
  methods: {
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    async reload() {
      this.isRouterShow = false;
      await this.$nextTick();
      this.isRouterShow = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.illegalWordView {
  padding-top: 60px;
  height: 100%;
  .illegalWord {
    width: 1360px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: flex-start;
    padding-top: 10px;
    .navLeft {
      height: 100%;
      z-index: 1;
      .navLeftRow {
        position: fixed;
      }
      .router-link-active {
        position: relative;
      }
      .is-active {
        background: #f9faff;
      }
      .is-active::after {
        content: "";
        height: 44px;
        width: 2px;
        background: #1c64f4;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    .content {
      height: 100%;
      margin-left: 10px;
      width: calc(100% - 160px);
      margin-left: 160px;
    }
  }
  .el-menu-vertical {
    width: 150px;
    height: 100%;
    padding-top: 10px;
    .navLeftItem {
      height: 44px;
      line-height: 44px;
    }
  }
}
@media screen and (max-width: 1440px) {
  .illegalWordView {
    .illegalWord {
      width: 1340px !important;
    }
  }
}
</style>
